import SuperTokens from 'supertokens-web-js';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import Session from 'supertokens-web-js/recipe/session';

SuperTokens.init({
  appInfo: {
    appName: 'Torim Platform Admin',
    apiDomain: import.meta.env.VITE_BACKEND_URL || 'http://localhost:3001',
  },
  recipeList: [
    EmailPassword.init(),
    Session.init(),
  ],
});
